import MarsText from './mars-text/index.vue';
export default (Vue) => {
   Vue.component('MarsText', MarsText);
}